import React from "react";
import { Link } from "react-router-dom";
import { Share2, ArrowRight } from "lucide-react";
import { useLang } from "@/lib/lang";
import { CHARACTERS, CHARACTER_GROUPS } from "@/lib/characters";
import { CharacterCard, CharacterCardStyles } from "@/components/CharacterCard";

export default function CharacterGallery() {
  const { lang } = useLang();
  return (
    <section id="personnages" data-testid="home-character-gallery" className="relative py-24 sm:py-28">
      <div className="hair absolute top-0 left-0 right-0" />
      <CharacterCardStyles />
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="max-w-3xl">
            <div className="overline mb-4"><span className="kicker-line" />
              {lang === "fr" ? "Galerie des personnages" : "Character gallery"}
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight">
              {lang === "fr" ? <>Choisis la <span className="italic" style={{ color: "var(--gold-glow)" }}>voix</span> qui te parle.</>
                : <>Choose the <span className="italic" style={{ color: "var(--gold-glow)" }}>voice</span> that speaks to you.</>}
            </h2>
            <p className="mt-4 text-base" style={{ color: "var(--violet-soft)" }}>
              {lang === "fr"
                ? "Bardes, druides, dieux grecs, archanges : chacun a son caractère, sa musique et sa manière de te répondre."
                : "Bards, druids, Greek gods, archangels: each has its own character, music and way of answering you."}
            </p>
          </div>
          <Link to="/decouvrir" data-testid="gallery-promo-btn" className="btn-gold inline-flex items-center gap-2 self-start lg:self-auto">
            <Share2 size={14} />
            {lang === "fr" ? "Page de présentation" : "Presentation page"}
            <ArrowRight size={14} />
          </Link>
        </div>

        {CHARACTER_GROUPS.map((g) => (
          <div key={g.id} className="mb-10" data-testid={`gallery-group-${g.id}`}>
            <div className="flex items-center gap-4 mb-4">
              <div className="text-xs font-mono uppercase tracking-[0.28em]" style={{ color: "var(--gold)" }}>
                {lang === "fr" ? g.fr : g.en}
              </div>
              {g.id === "elements" && (
                <Link to="/elements" data-testid="gallery-elements-hub-link" className="text-xs font-mono underline" style={{ color: "var(--violet-soft)" }}>
                  {lang === "fr" ? "Page des éléments →" : "Elements page →"}
                </Link>
              )}
            </div>
            <div className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 ${g.id === "elements" ? "lg:grid-cols-7" : "lg:grid-cols-6"} gap-4`}>
              {CHARACTERS.filter((c) => c.group === g.id).map((c) => (
                <CharacterCard key={c.id} c={c} testPrefix="gallery" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
